function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tickmark",
  transform: "translate(-289.758 -419.758)"
}, React.createElement("g", {
  id: "circle",
  transform: "translate(289.758 419.758)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1,
  opacity: 0.3
}, React.createElement("circle", {
  cx: 13.242,
  cy: 13.242,
  r: 13.242,
  stroke: "none"
}), React.createElement("circle", {
  cx: 13.242,
  cy: 13.242,
  r: 12.742,
  fill: "none"
})), React.createElement("path", {
  id: "tick",
  d: "M123.4,157.2a.474.474,0,0,1-.3-.1l-4.754-3.8a.475.475,0,0,1,.594-.743l4.4,3.521,7.306-8.219a.475.475,0,0,1,.711.631l-7.606,8.556A.475.475,0,0,1,123.4,157.2Z",
  transform: "translate(177.764 280.893)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}));
var SvgTickmark = function SvgTickmark(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 26.484,
    height: 26.484,
    viewBox: "0 0 26.484 26.484",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tickmark.70891c53.svg";
export { ForwardRef as ReactComponent };